<script>
import Layout from '@layouts/adminLayout.vue'
import Security from '@views/settings/security.vue'

export default {
  page: {
    title: 'Security',
    meta: [{ name: 'description', content: 'The Security page.' }],
  },
  components: { Security, Layout },
}
</script>

<template>
  <Layout>
    <Security></Security>
  </Layout>
</template>
